// extracted by mini-css-extract-plugin
module.exports = {"card":"HintButton_card__3KMTz","text":"HintButton_text__1Uuin"};